import { ProjectDownloadRecord } from '../types';
import apiRequest from './apiRequest';

type ApiResponse = {
  records: ProjectDownloadRecord[];
  nextToken?: string;
};

export default async function getDownloadHistory({
  limit,
  nextToken,
  sortAscending,
}: {
  limit?: number;
  nextToken?: string;
  sortAscending?: boolean;
}) {
  const urlParams = new URLSearchParams();
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (sortAscending !== undefined) {
    urlParams.set('sortAscending', sortAscending.toString());
  }

  return apiRequest<ApiResponse>(
    'user',
    `/users/projectDownloads${urlParams.toString() ? '?' : ''}${urlParams.toString()}`,
  );
}
